(function($) {
    if ($('#heroFront').length) {
        $('#siteHeader')
            .removeClass('site-header-dark')
            .addClass('site-header-light');

        /* Animates underline in main overlay */
        setTimeout(function() {
            $('#heroFront .block-overlay')
            .find('.object-underline-large')
            .attr('data', '/assets/images/scribbles/animated/front/scribble-underline-large.svg')
        }, 500);

        /* Animates underline on initial slide */
        setTimeout(function() {
            $('#frontSlider .slider-item')
                .find('.object-underline-large')
                .attr('data', '/assets/images/scribbles/animated/front/scribble-underline-large.svg')
        }, 1000);
    }

    /* Slider */
    $('#frontSlider').on('afterChange', function(event, slick, currentSlide, nextSlide) {
        $('#frontSlider .slider-item').each(function() {
            $this = $(this);

            if ($this.hasClass('slick-current')) {

                // circle animation
                $this
                    .find('.object-circle')
                    .attr('data', '/assets/images/scribbles/animated/front/scribble-circle.svg')

                // underline animation (small)
                $this
                    .find('.object-underline-small')
                    .attr('data', '/assets/images/scribbles/animated/front/scribble-underline-small.svg')

                // underline animation (large)
                $this
                    .find('.object-underline-large')
                    .attr('data', '/assets/images/scribbles/animated/front/scribble-underline-large.svg')

            } else {
                setTimeout(function() {
                    $('#frontSlider .slider-item:not(.slick-current)')
                        .find('.object-element')
                        .attr('data', '');
                }, 200);
            }
        });
    });

}(jQuery));

